'use strict';

var $ = require('jquery');
var AnimationEasing = require('../lib/AnimationEasing.js');
var Debouncer = require('../lib/Debouncer.js');
var Range = require('../lib/Range.js');
var ViewportTracker = require('../lib/ViewportTracker.js');

function addVisualMark(container, label, color, top) {
	var div = document.createElement('div');
	
	//if (container === document.documentElement) {
	//	document.getElementsByTagName('body')[0].appendChild(div);
	//} else {
		container.appendChild(div);
	//}
	
	div.appendChild(document.createTextNode(label));
	div.style['border-top'] = '2px solid ' + color;
	div.style.color = color;
	div.style.position = 'absolute';
	div.style.right = '0px';
	div.style.top = top + 'px';
	div.style['z-index'] = 10000;
	div.style['font-weight'] = 'bold';
	//div.className = 'animationVisualMark';
	
	return div;
}

function resolve(o) {
	if (o !== undefined && typeof o.value === 'function')
		return o.value();
	return o;
}

/* ===============================================================================
 * ScrollController  - Uses the scroll position
 */
function ScrollController(config) {
	this.indicator = config !== undefined && config.indicator !== undefined ? config.indicator : 0;
	
	if (config.container) {
		this.container = config.container;
		this.containerScrollArea = this.container;
	} else {
		this.container = document.getElementsByTagName('body')[0];
		this.containerScrollArea = window;
	}
	
	this._queueUpdateAreas = (new Debouncer(this._queueUpdateAreas.bind(this))).run;
	this.start = this.start.bind(this);
	this.stop = this.stop.bind(this);
}
ScrollController.prototype.start = function(manager) {
	var self = this;
	
	this.manager = manager;
	
	this.indicatorAdjustment = manager.valueHolder(function() {
		var heightOfArea;
		if (self.containerScrollArea === window) {
			heightOfArea = window.innerHeight;
		} else {
			heightOfArea = self.container.getBoundingClientRect().height;
		}

		return heightOfArea * self.indicator;
	});
	
	if (manager.debug) {
		var indicatorTop = this.indicatorAdjustment.value();
		
		var div = addVisualMark(this.container, 'Indicator', 'orange', indicatorTop);
		div.style.position = 'fixed';
		
		var areas = manager.getAreas();
		for (var i=0; i < areas.length; i++) {
			var area = areas[i];
			console.log('Construct Area ' + area.label + ' start, end, endPointPercent:', area.start, area.end, area.endPointPercent);
			if (area.start !== undefined) {
				addVisualMark(this.container, 'Start: ' + area.label, 'green', area.start);
			}
			if (area.end !== undefined) {
				addVisualMark(this.container, 'End: ' + area.label, 'red', area.end);
			}
		}
	}
	
	this.containerScrollArea.addEventListener('scroll', this._queueUpdateAreas);
	this._queueUpdateAreas();
}
ScrollController.prototype.stop = function(manager) {
	this.containerScrollArea.removeEventListener('scroll', this._queueUpdateAreas);
	
	// IMP: We add indicators during start. start called multiple times (page resize, etc). We never remove
	// 		indicators so they pile up. Would be great if we removed them here.
}
ScrollController.prototype._queueUpdateAreas = function() {
	var scrollY;
	if (this.containerScrollArea === window) {
		scrollY = (window.pageYOffset || document.documentElement.scrollTop);
	} else {
		scrollY = this.container.scrollTop;
	}
	
	scrollY += this.indicatorAdjustment.value();
	
	this.manager.updateValue(scrollY);
}

/* ===============================================================================
 * TimelineController  - Uses the scroll position
 */
function TimelineController(config) {
	this._totalTime = config.totalTime;
	
	this._update = this._update.bind(this);
	this._registerUpdateRAF = this._registerUpdateRAF.bind(this);
	this.start = this.start.bind(this);
	this.stop = this.stop.bind(this);

	this._start = 0;
	this._end = 0;
	this._lastPosition = 0;
	this._lastTimestamp = undefined;
	this._reverse = false;
	
	this._updateCalculations();
}

TimelineController.prototype.start = function(manager) {
	var self = this;
	this.manager = manager;
	
	this._start = 0;
	this._end = 0;
	var areas = manager.getAreas();
	for (var i=0; i < areas.length; i++) {
		var area = areas[i];
		if (area.end > this._end) {
			this._end = area.end;
		}
	}
	this._updateCalculations();
	if (this._lastPosition !== undefined) {
		this._lastPosition = this._checkInBounds(this._lastPosition);
	}
	
	//this.play();
}
TimelineController.prototype.stop = function(manager) {
	this.pause();
}

TimelineController.prototype.play = function(manager) {
	this._update();
}
TimelineController.prototype.pause = function(manager) {
	if (this._rafID !== undefined) {
		cancelAnimationFrame(this._rafID);
	}
}
TimelineController.prototype.reset = function(manager) {
	this.stop();
	this._lastTimestamp = undefined;
}
TimelineController.prototype.setReverse = function(reverse) {
	this._reverse = reverse;
}

TimelineController.prototype._registerUpdateRAF = function(timestamp) {
	if (this._rafID === undefined) {
		this._rafID = requestAnimationFrame(this._update);
		this._rafID = undefined;
	}
}
TimelineController.prototype.setPosition = function(position) {
	this._lastPosition = position;
}
TimelineController.prototype.setTotalTime = function(totalTime) {
	this._totalTime = totalTime;
	this._updateCalculations();
}
TimelineController.prototype._checkInBounds = function(position) {
	if (position < this._start) {
		position = this._start;
	} else if (position > this._end) {
		position = this._end;
	}
	return position;
}
TimelineController.prototype._update = function(timestamp) {
	var timeThatHasPassed;
	if (timestamp === undefined || this._lastTimestamp === undefined) {
		timeThatHasPassed = 0;
	} else {
		timeThatHasPassed = timestamp - this._lastTimestamp;
	}
	
	var adjustment = this._millisecondsEqualTo * timeThatHasPassed;
	if (this._reverse) {
		adjustment = adjustment * -1;
	}
	
	var position = this._lastPosition + adjustment;
	position = this._checkInBounds(position);
	
	if (this.manager.debug) {
		var percentThroughTotalTime;
		percentThroughTotalTime = position / (this._end - this._start);
		if (this._reverse) {
			percentThroughTotalTime = 1 - percentThroughTotalTime;
		}
		console.log('Animation at ' + position + ' : ' + (percentThroughTotalTime*100) + '%');
	}
	
	this.manager.updateValue(position);
	
	this._lastTimestamp = timestamp;
	this._lastPosition = position;
	
	this._rafID = undefined;
	//if (percentThroughTotalTime < 1) {
	if (
			(this._reverse && position > this._start)
			|| (!this._reverse && position < this._end)
		) {
		this._registerUpdateRAF();
	}
}
TimelineController.prototype._updateCalculations = function() {
	this._millisecondsEqualTo = (this._end - this._start) / this._totalTime;
}


/* ===============================================================================
 * ValueHolder
 * 
 * valueFunction is called when value() is called and it hasn't been called before, or
 * if update() has been called since value() was called last.
 * 
 * updateFunction is optional. It is called when update() is called.
 */
function ValueHolder(valueFunction, updateFunction) {
	this.update = this.update.bind(this);
	
	this._valueFunction = valueFunction;
	this._updateFunction = updateFunction;
	this._needUpdate = true;
}
ValueHolder.prototype.value = function() {
	this._value = this._valueFunction();
	this._needUpdate = false;
	return this._value;
}
ValueHolder.prototype.update = function() {
	this._needUpdate = true;
	if (this._updateFunction !== undefined) {
		this._updateFunction = this._updateFunction();
	}
}

/* ===============================================================================
 * Manager
 * 
 * It is recommended you setup animations after the DOM is ready by placing your
 * code inside:
 * 
	$(function() {
		...
	})
 */
function Manager(config) {
	this.debug = config !== undefined && config.debug || false;
	
	this.running = false;
	this._setupHasHappened = false;
	
	if (config !== undefined && config.controller !== undefined) {
		this.controller = config.controller;
	} else {
		this.controller = new ScrollController(config);
	}
	
	this.update = this.update.bind(this);
	
	this.values = [];
	this.areas = [];

	this.setupFunctions = [];
	if (config.setup !== undefined) {
		this.addSetup(config.setup);
	}
	
	// ValueHolder related code.
	this._debouncedSetup = (new Debouncer(this.setup.bind(this), false, 1000)).run;
	window.addEventListener('resize', this._debouncedSetup);
	window.addEventListener('fontsLoaded', this._debouncedSetup);
	$('img').one('load', this._debouncedSetup);
}

var instances = {};
Manager.setInstance = function(name, manager) {
	instances[name] = manager;
};
Manager.getInstance = function(name) {
	return instances[name];
};

Manager.prototype.resetAreas = function() {
	// Tell all areas to reset back to original
	if (this.areas !== undefined) {
		for (var i=0; i < this.areas.length; i++) {
			var area = this.areas[i];
			area.reset(this);
		}
	}
}
Manager.prototype.clearAreas = function() {
	this.resetAreas();
	
	this.areas = [];
}
Manager.prototype.getAreas = function() {
	return this.areas;
}
Manager.prototype.addArea = function(area) {
	this.areas.push(area);
}

Manager.prototype.addSetup = function(setup) {
	this.setupFunctions.push(setup);

	if (this._setupHasHappened === true) {
		this.setup();
	}
}

/**
 * Stops self momentarily to clears areas and call the setup function configured with. Setup function
 * will create new areas. 
 */
Manager.prototype.setup = function() {
	this._setupHasHappened = true;
	
	var isRunning = this.running;
	if (isRunning)
		this.stop();
	
	this.clearAreas();
	
	for (var i=0; i < this.setupFunctions.length; i++) {
		this.setupFunctions[i](this);
	}
	
	for (var i=0; i < this.values.length; i++) {
		this.values[i].update();
	}
	
	if (isRunning) {
		this.start();
	}
}
Manager.prototype.start = function() {
	if (this._setupHasHappened !== true) {
		this.setup();
	}
	
	if (this.running)
		return;
	this.running = true;
	
	if (this.debug)
		console.log('Starting Manager');
	
	this._rafID = undefined;
	this.controller.start(this);
	
	this.update();
}
Manager.prototype.stop = function() {
	if (this._rafID !== undefined) {
		cancelAnimationFrame(this._rafID);
		this._rafID = undefined;
	}
	
	if (!this.running)
		return;
	this.running = false;
	
	if (this.debug)
		console.log('Stopping Manager');
	
	this.controller.stop(this);
	
	this.resetAreas();
}
Manager.prototype.updateValue = function(value) {
	this.value = value;
	
	if (this.running) {
		if (this._rafID === undefined) {
			this._rafID = window.requestAnimationFrame(this.update);
		}
	}
}
Manager.prototype.update = function() {
	if (this.value === undefined) {
		return;
	}
	
	for (var i=0; i < this.areas.length; i++) {
		var area = this.areas[i];
		area.update(this.value, this);
	}
	
	this._rafID = undefined;
}
/**
 * Create new ValueHolder
 */
Manager.prototype.valueHolder = function(valueFunction, updateFunction) {
	var r = new ValueHolder(valueFunction, updateFunction);
	this.values.push(r);
	return r;
}

/* ===============================================================================
 * Area
 */
function AreaCustom(label, percentFunction, handlers) {
	this.label = label;
	this.percentFunction = percentFunction;
	this.handlers = handlers;
}
AreaCustom.prototype.reset = function(manager) {
	if (manager.debug) {
		console.log("Reset area '" + this.label + "'");
	}
	
	if (this.handlers !== undefined) {
		for (var i=0; i < this.handlers.length; i++) {
			var handler = this.handlers[i];
			if (typeof handler.reset === 'function') { 
				handler.reset(this, manager);
			}
		}
	}
}
AreaCustom.prototype.update = function(value, manager) {
	// Determine percentage through animation
	var origValue = value;
	
	var percentage = this.percentFunction(value, manager);
	
	if (manager.debug) {
		console.log("Update area '" + this.label + "' y:" + value + " %: " + percentage, origValue, value, this.endPoint);
	}
	
	// Notify handlers
	if (this.handlers !== undefined) {
		for (var i=0; i < this.handlers.length; i++) {
			var handler = this.handlers[i];
			if (typeof handler.update == 'function') {
				handler.update(percentage, this, manager);
			}
		}
	}
}
/**
 * endPointPercent = Defines where we consider the animation at 1 (100%)
 * 						Value	% at top	% at middle		% at bottom
 * 						0		1			.5				0
 * 						.5		0			1				0
 * 						1		0			.5				1
 */
function Area(label, start, end, endPointPercent, handlers) {
	AreaCustom.call(this, label, this._determinePercentage, handlers);
	this.endPointPercent = endPointPercent === undefined ? 1 : endPointPercent;
	
	this.setRange(start, end);
}
Area.prototype = Object.create(AreaCustom.prototype);
Area.prototype.setRange = function(start, end) {
	this.start = start;
	this.end = end;
	this._updateCalculations();
}
Area.prototype._updateCalculations = function() {
	var diff = this.end - this.start;
	
	this.endPoint = this.start + (diff * this.endPointPercent);
	
	this.bottomAreaHeight = this.end - this.endPoint;
	this.topAreaHeight = diff - this.bottomAreaHeight;
}
Area.prototype._determinePercentage = function(value, manager) {
	var percentage;
	if (this.start === this.end) {
		percentage = value >= this.start ? 1 : 0;
	} else {
		// Act as if on edge of area if outside area
		if (value < this.start) {
			value = this.start;
		} else if (value > this.end) {
			value = this.end;
		}
		
		// Determine percentage location in area moving within
		if (value >= this.endPoint) {
			// Moving after or at endPoint
			percentage = (this.bottomAreaHeight == 0) ? 1: (
					(this.end - value) // Distance
					/ this.bottomAreaHeight
				);
		} else {
			// Moving before endPoint
			percentage = (this.topAreaHeight == 0) ? 0 : (
					(value - this.start)	// Distance
					/ this.topAreaHeight
				);
		}
	}
	return percentage;
}

/* ===============================================================================
 * CSSProperty
 */
/**
 * Adds class when percentage greater than 0
 */
function CSSProperty(elem, prop, determineNewValue) {
	this.elem = elem;
	this.prop = prop;
	
	if (determineNewValue instanceof Range) {
		this.determineNewValue = function(p, area) {
			return determineNewValue.valueAt(p);
		};
	} else {
		this.determineNewValue = determineNewValue;
	}
	
	this.originalValue = elem.get(0).style[prop];
}
CSSProperty.prototype.reset = function(area, manager) {
	this.elem.css(this.prop, this.originalValue);
	
	if (manager.debug) {
		console.log('\tOn "' + area.label +  '" reset CSSProperty, "' + this.prop + '" to "' + this.originalValue + '"');
	}
}
CSSProperty.prototype.update = function(percentage, area, manager) {
	var newValue = this.determineNewValue(percentage, area);
	this.elem.css(this.prop, newValue);
	
	if (manager.debug) {
		console.log('\tOn "' + area.label +  '" change ' + this.prop + ' to ' + newValue + ' since at percentage ' + percentage);
	}
}

/* ===============================================================================
 * StyleClass
 */
function StyleClass(elem, styleClass) {
	this.elem = elem;
	this.styleClass = styleClass;
	
	this.originalHasClass = elem.hasClass(styleClass);
}
StyleClass.prototype.reset = function(area, manager) {
	this.elem.toggleClass(this.styleClass, this.originalHasClass);
	if (manager.debug) {
		console.log("\tReset StyelClass, " + (this.originalHasClass ? "adding" : "removing") + " class: " + this.styleClass);
	}
}
StyleClass.prototype.update = function(percentage, area, manager) {
	var inside = percentage > 0;
	if (this.currInside === undefined || this.currInside !== inside) {
		this.elem.toggleClass(this.styleClass, inside);
		this.currInside = inside;
		if (manager.debug) {
			console.log('	' + (inside?'Add ':'Remove ') + '"' + area.label + '" class "', this.styleClass, '" since at percentage ', percentage);
		}
	} else {
		if (manager.debug) {
			console.log('	No change "' + area.label + '" ', percentage, this.currInside, inside);
		}
	}
}

/* ===============================================================================
 * StyleClassRemoveOnce
 * 
 * Handler that adds a styleClass and removes it once hit area
 */
function StyleClassRemoveOnce(elem, styleClass) {
	this.elem = elem;
	this.styleClass = styleClass;
	this.state = 0;
	
	this.originalHasClass = elem.hasClass(styleClass);
}
StyleClassRemoveOnce.prototype.reset = function(area) {
	this.state = 0;
	this.elem.toggleClass(this.styleClass, this.originalHasClass);
}
StyleClassRemoveOnce.prototype.update = function(percentage, area) {
	if (percentage === 0) {
		if (this.state < 1) {
			this.state = 1;
			this.elem.addClass(this.styleClass);
		}
	} else if (this.state !== 2 && percentage > 0) {
		this.elem.removeClass(this.styleClass);
		this.state = 2;
	}
}

/* ===============================================================================
 * CustomHandler
 */
function CustomHandler(updateFunction, resetFunction) {
	this.updateFunction = updateFunction;
	this.resetFunction = resetFunction;
}
CustomHandler.prototype.reset = function(area) {
	if (this.resetFunction !== null) {
		this.resetFunction(area);
	}
}
CustomHandler.prototype.update = function(percentage, area) {
	if (this.updateFunction !== null) {
		this.updateFunction(percentage, area);
	}
}

/* ===============================================================================
 * Util function that starts and stops animations based on view port
 */
function runConditionalOnViewport(manager, ifRunFunction) {
	function onViewportState() {
		if (ifRunFunction(ViewportTracker.getState())) {
			manager.start();
		} else {
			manager.stop();
		}
	}
	
	onViewportState();
	$(window).on('ViewportTracker:state', onViewportState);
}

module.exports = {
	Manager: Manager,
	ScrollController: ScrollController,
	TimelineController: TimelineController,
	AreaCustom: AreaCustom,
	Area: Area,
	CSSProperty: CSSProperty,
	StyleClass: StyleClass,
	StyleClassRemoveOnce: StyleClassRemoveOnce,
	CustomHandler: CustomHandler,
	ValueHolder: ValueHolder,
	runConditionalOnViewport: runConditionalOnViewport
};
